<template>
	<div class="Footer-social">
		<a
			v-for="(social, socialKey) in social"
			:key="socialKey"
			:href="social.href"
			:title="$t(social.label)"
			:aria-label="$t(social.label)"
		>
			<CloIcon :symbol="social.icon" />
		</a>
	</div>
</template>

<script>
import CloIcon from '@/icons/CloIcon/CloIcon.vue';
export default {
	name: 'CloFooterSocial',
	components: { CloIcon },
	props: {
		social: {
			type: Array,
			required: true,
		},
	},
};
</script>

<style lang="scss">
.Footer-social {
	display: flex;
	flex-wrap: wrap;
	gap: $space-sm $space-md;
	@include stack-sm;
	a {
		@include interactiveColor('color', $color-white, $color-link-reverse);
	}
}
</style>
